import type { RestaurantDetails } from "@/API";
import type { FC } from "react";
import { Skeleton } from "../ui/skeleton";
import KrunshScoreCard from "../KrunshScoreCard";

type Props = {
  restaurant?: RestaurantDetails;
  isLoading?: boolean;
  isBlured?: boolean;
};

const RestaurantKrunshScore: FC<Props> = ({
  isLoading,
  restaurant,
  isBlured,
}) => {
  if (isLoading) return <Skeleton />;

  if (!restaurant) return null;

  const { krunshScore, krunshScoreDetails } = restaurant;

  return (
    <KrunshScoreCard
      krunshScore={krunshScore}
      krunshScoreDetails={krunshScoreDetails}
      isBlured={isBlured}
    />
  );
};

export default RestaurantKrunshScore;
